import React from 'react';
import './style.scss';
import Menu from '../../components/menu';
import ScrollContainer from '../../components/scroll-container';
import { motion } from 'framer-motion';

const NotFound: React.FC = () => {
	return (
		<>
			<Menu />
			<ScrollContainer>
				<motion.div
					className="page-content__inner coverage-container"
					initial={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: false, amount: 0.25 }}
					transition={{ duration: 0.5, ease: 'easeOut' }}
				>
					<motion.h2
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: false, amount: 0.25 }}
						transition={{ duration: 0.5, delay: 0.2 }}
					>
						404 Not Found
					</motion.h2>
					<motion.h5
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: false, amount: 0.25 }}
						transition={{ duration: 0.5, delay: 0.2 }}
					>
						Halaman tidak ditemukan
					</motion.h5>
				</motion.div>
			</ScrollContainer>
		</>
	);
};

export default NotFound;
